import type { GiftPassBundlePreviewPrice } from '@bonsai/shared';

import '../../shared/editor-page/editor-page.css';

import { BundleDiscountSection } from './BundleDiscountSection';
import { BundleNameSection } from './BundleNameSection';
import { BundlePassCountSection } from './BundlePassCountSection';
import { BundleTagsSection } from './BundleTagsSection';
import type { BundleEditor } from './use-bundle-editor';

export interface BundleFormCardProps {
  editor: BundleEditor;
  atFallback: GiftPassBundlePreviewPrice | null;
}

export function BundleFormCard({ editor, atFallback }: BundleFormCardProps) {
  const { values, errors, set } = editor;
  return (
    <section className="nb-card nb-ed-form-card" aria-label="Bundle details">
      <BundleNameSection
        value={values.name}
        error={errors.name}
        onChange={(name) => set({ name })}
      />
      <BundlePassCountSection
        value={values.passCount}
        error={errors.passCount}
        onChange={(passCount) => set({ passCount })}
      />
      <BundleDiscountSection
        discountType={values.discountType}
        amount={values.amount}
        atFallback={atFallback}
        error={errors.amount}
        onChange={set}
      />
      <BundleTagsSection tags={values.tags} errors={errors} onChange={(tags) => set({ tags })} />
    </section>
  );
}
